import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import App from './App.vue'
import routes from './router/routes'
import { setupRouterGuard } from './router/guards'
import './styles/global.css'

// 创建应用实例
const app = createApp(App)

// 创建路由实例
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 })
})

// 配置路由守卫
setupRouterGuard(router)

// 创建Pinia实例
const pinia = createPinia()

// 配置VueQuery
VueQueryPlugin.install(app, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5分钟
        retry: 1
      }
    }
  }
})

// 安装插件
app.use(pinia)
app.use(router)

// 开发环境添加VueQuery Devtools
if (import.meta.env.DEV) {
  app.use(VueQueryDevtools)
}

// 挂载应用
app.mount('#app')
